import { carleadQuestionnairePartialFlow } from './partialQuestionnaireFlows';
export const defaultCarleadCreationFlow = {
  initial: {
    name: 'manufacturer',
    next: ['mainType'],
    nodeType: 'dataField',
    inputFieldType: 'select'
  },
  mainType: {
    name: 'mainType',
    next: ['builtDate'],
    nodeType: 'dataField',
    inputFieldType: 'select'
  },
  builtDate: {
    name: 'builtDate',
    next: ['bodyType'],
    nodeType: 'dataField',
    inputFieldType: 'select'
  },
  bodyType: {
    name: 'bodyType',
    next: ['mainTypeDetail'],
    nodeType: 'dataField',
    inputFieldType: 'select'
  },
  mainTypeDetail: {
    name: 'mainTypeDetail',
    next: ['mainTypeSub'],
    nodeType: 'dataField',
    inputFieldType: 'select'
  },
  mainTypeSub: {
    name: 'mainTypeSub',
    next: ['mileage'],
    nodeType: 'dataField',
    inputFieldType: 'select'
  },
  mileage: {
    name: 'mileage',
    next: ['SELLPOINT'],
    nodeType: 'normalField',
    inputFieldType: 'select'
  },
  email: {
    name: 'email',
    next: ['finish'],
    nodeType: 'normalField',
    inputFieldType: 'text'
  },
  finish: {
    name: 'finish',
    nodeType: 'normalField',
    inputFieldType: 'select',
    next: []
  },
  ...carleadQuestionnairePartialFlow
};